import { Auth } from 'aws-amplify'
import UpdateMovieListdataservice from '../../Services/Mutations/UpdateMovieListdata'

const UpdateMovieListData = async (selectedListType, listId, selectedData) => {
  const moveieOrPersoninfo = selectedData.map((moviepersoninfo, index) => ({
    ID: moviepersoninfo.PK.includes('movieList#')
      ? moviepersoninfo.SK.includes('Text#')
        ? moviepersoninfo.SK.replace('Text#', '')
        : moviepersoninfo.SK
      : moviepersoninfo.PK,
    listItemDescription_En: moviepersoninfo.listItemDescription
      ? moviepersoninfo.listItemDescription
      : '',
    listItemDescription_Te: moviepersoninfo.listItemDescription_Te
      ? moviepersoninfo.listItemDescription_Te
      : '',
    listItemImage:
      moviepersoninfo && moviepersoninfo.listItemImage
        ? moviepersoninfo.listItemImage
        : moviepersoninfo.posterURL,
    listItemTitle_En: moviepersoninfo.listItemTitle_En,
    listItemTitle_Te: moviepersoninfo.listItemTitle_Te,
    youtubeEmbedLink: moviepersoninfo.youtubeEmbedLink ? moviepersoninfo.youtubeEmbedLink : '',
    priority: index,
  }))
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const input = {
    movieListID: listId.includes('movieList#') ? listId : `movieList#${listId}`,
    movieListCategory: selectedListType,
    addedByID: Auth.user.username,
    addedByHandle: loggedInUserHandle,
    movieOrPersonInfo: moveieOrPersoninfo,
  }

  try {
    const response = await UpdateMovieListdataservice(input)

    return response
  } catch (error) {
    console.warn(error)
  }
}

export default UpdateMovieListData
